import { Image } from "@mantine/core";

import { type Fuzzy as FuzzyBall, FUZZY_SOURCES } from "~/helpers/fuzzies";

import classes from "./FuzzyBall.module.css";

export interface FuzzyBallProps extends BoxProps {
  fuzzy: FuzzyBall;
  breathing?: boolean;
  glowing?: boolean;
}

const FuzzyBall: FC<FuzzyBallProps> = ({
  fuzzy,
  breathing,
  glowing,
  className,
  ...otherProps
}) => {
  return (
    <Box
      pos="relative"
      className={cn("FuzzyBall-root", classes.root, className)}
      mod={{ breathing, glowing }}
      {...otherProps}
    >
      <Image src={FUZZY_SOURCES[fuzzy]} className={classes.image} />
    </Box>
  );
};

export default FuzzyBall;
